import validate from "/usr/src/app/content/n3-packages-18d26ca2-3491-41d2-80fe-9ee10f100ca0/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-packages-18d26ca2-3491-41d2-80fe-9ee10f100ca0/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}